<template>
  <div>
    <a-card :title="`Institutions of ${application.ew_app_name}`" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="addNewInstitution()">Add</a-button>
        <table class="table table-hover" v-if="application.institutions.length">
            <tr>
                <th>Institution Name</th>
                <th>Actions</th>
            </tr>
            <tr v-for="(item,i) in application.institutions" :key="i">
                <td>{{item.ew_ins_name}}</td>
                <td>
                    <router-link :to="{ path: `/application/${item.ew_app_id}/institutions/${item.ew_ins_id}`}" class="btn-info btn-sm" exact> 
                      <span class="ti-book" title="View / Edit"></span>
                    </router-link> | 

                    <a-popconfirm
                        title="Are you sure delete this institution?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="deleteInstitution(item.ew_ins_id)"
                        @cancel="cancel"
                    >
                        <a-button type="danger" title="Delete!" size="small">
                            <span class="ti-trash"></span>
                        </a-button>
                    </a-popconfirm>
                </td>
            </tr>
        </table>
        <a-empty v-else>  <span slot="description">No Institutions! </span></a-empty>
    </a-card>
  </div>
</template>
<script>

import API from '../../../services/api';

export default {
  props:['application','addNewInstitutionHost','addNewInstitution','deleteInstitution','showModal'],
  data(){
      return {

      }
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
  },
  methods: {
    goBack(){
      return this.$router.go(-1)
    },
    cancel(){

    }
  }
};
</script>
<style>
</style>
